/* Shared DOM helpers — the $, $$, on, esc primitives every hub module uses.
   Extracted from the former single-IIFE assets/hub/hub.js. ES-module strict
   mode is implicit, so the old `'use strict'` pragma is gone. */
export const doc = document;
export const body = document.body;

export function $(sel, root) { return (root || doc).querySelector(sel); }
export function $$(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
export function on(el, evt, fn) { if (el) { el.addEventListener(evt, fn); } }
export function esc(s) {
	return String(s == null ? '' : s)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
